import React from "react";
import { Helmet } from "react-helmet";
import Welfare from "@coninsa-site/welfare";

import Layout from "../layout/default/Layout.js";

export default function WelfarePage() {
  return (
    <Layout>
      <Helmet>
        <title>Bienestar | Coninsa</title>
        <meta name="description" content="Pagina de bienestar Coninsa.co" />
      </Helmet>
      <Welfare />
    </Layout>
  );
}
